<template>
  <div>
    <h1>{{ text }}</h1>
    <button @click="text = '我是新的一'">监听</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: '我是旧一',
    };
  },
  watch: {
    //监听器的作用就是用来监听数据是否发生了变化，变化后可以进行一些其他操作
    //只要没有发生变化，就没有办法进行其他的操作

    text: function (newData, oldData) {
      //newData是更新后的数据
      //oldData是旧数据
      console.log(newData, oldData)
      this.text = '我是最新的一'
    }
  },
  created() {
  },
  methods: {},
};
</script>

<style>

</style>
